import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import configureStore, { getPersist } from "./core/redux/index";
import { PersistGate } from "redux-persist/integration/react";
const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={getPersist()}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
